import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#fff"
        d="M2 8.667h4V7.333H2V1.231a.333.333 0 01.494-.292l12.308 6.769a.333.333 0 010 .584l-12.308 6.77A.333.333 0 012 14.768V8.667z"
      ></path>
    </svg>
  )
}

export default Icon
